// Third party packages
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
// Custom packages
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
import * as i3 from "@ngx-translate/core";
var InterventionsService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function InterventionsService(apiService, helperService, translateService) {
        this.apiService = apiService;
        this.helperService = helperService;
        this.translateService = translateService;
    }
    /**
     * Create a new intervention
     *
     * @since 1.0.0
     *
     * @param intervention Intervention data
     * @returns Observable<any>
     */
    InterventionsService.prototype.create = function (intervention) {
        return this.apiService.apiCall('POST', 'interventions', intervention);
    };
    /**
     * Add a contractor to intervention contractors
     *
     * @since 1.0.0
     * @returns Observable<any>
     */
    InterventionsService.prototype.createContractor = function (interventionId, contractor) {
        return this.apiService.apiCall('POST', "interventions/" + interventionId + "/contractors", contractor);
    };
    /**
     * Add a taxDeductionFee to intervention taxDeductionFees
     *
     * @since 1.0.0
     * @returns Observable<any>
     */
    InterventionsService.prototype.createTaxDeductionFee = function (interventionId, taxDeductionFee) {
        return this.apiService.apiCall('POST', "interventions/" + interventionId + "/taxDeductionFees", taxDeductionFee);
    };
    /**
     * Add a receivedDocument to intervention receivedDocuments
     *
     * @since 1.0.0
     * @returns Observable<any>
     */
    InterventionsService.prototype.createReceivedDocument = function (interventionId, receivedDocument) {
        return this.apiService.apiCall('POST', "interventions/" + interventionId + "/receivedDocuments", receivedDocument);
    };
    /**
     * Get interventions list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    InterventionsService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', 'interventions', params);
    };
    // /**
    //  * Get interventions list for given query params
    //  *
    //  * @since 1.0.0
    //  *
    //  * @param [start] Query left offset
    //  * @param [limit] Results number
    //  * @param [sort] Sorting field name
    //  * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
    //  * @param [search] Filtering object with fildering data string
    //  */
    // getPropertyList(propertyId: string, start?: number, limit?: number, sort?: string, sortVersus?: string, search?: any): Observable<ListApiResponseV2> {
    //   const params: any = { start, limit, sort, sortVersus };
    //   if (search) {
    //     search = {
    //       ...search,
    //       propertyId
    //     };
    //     Object.keys(search).forEach(key => {
    //       const newParamKey = `search[${key}]`;
    //       const newParamValue = search[key];
    //       params[newParamKey] = newParamValue;
    //     });
    //   }
    //   return this.apiService.apiCall('GET', 'interventions', params);
    // }
    // /**
    //  * Get interventions list for given query params
    //  *
    //  * @since 1.0.0
    //  *
    //  * @param [start] Query left offset
    //  * @param [limit] Results number
    //  * @param [sort] Sorting field name
    //  * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
    //  * @param [search] Filtering object with fildering data string
    //  */
    // getCompanyList(companyId: string, start?: number, limit?: number, sort?: string, sortVersus?: string, search?: any): Observable<ListApiResponseV2> {
    //   const params: any = { start, limit, sort, sortVersus };
    //   if (search) {
    //     search = {
    //       ...search,
    //       companyId
    //     };
    //     Object.keys(search).forEach(key => {
    //       const newParamKey = `search[${key}]`;
    //       const newParamValue = search[key];
    //       params[newParamKey] = newParamValue;
    //     });
    //   }
    //   return this.apiService.apiCall('GET', 'interventions', params);
    // }
    /**
     * Get an exportation file of all interventions
     *
     * @since 1.0.0
     */
    InterventionsService.prototype.getExport = function () {
        var _this = this;
        return this.apiService.apiCall('GET', 'interventions/export', {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get given interventionId data from back-end
     *
     * @since 1.0.0
     *
     * @param interventionId ID of the intervention to get
     */
    InterventionsService.prototype.get = function (interventionId) {
        var _this = this;
        return this.apiService.apiCall('GET', "interventions/" + interventionId).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Update intervention with given interventionId with given intervention data
     *
     * @since 1.0.0
     *
     * @param interventionId ID of intervention to update
     * @param data New intervention's data
     */
    InterventionsService.prototype.update = function (interventionId, data) {
        return this.apiService.apiCall('PUT', "interventions/" + interventionId, data);
    };
    /**
     * Update intervention with given interventionId with given intervention data
     *
     * @since 1.0.0
     *
     * @param interventionId ID of intervention to update
     * @param contractorId ID of contractor to update
     * @param data New contractor's data
     */
    InterventionsService.prototype.updateContractor = function (interventionId, contractorId, data) {
        var _this = this;
        return this.apiService.apiCall('PUT', "interventions/" + interventionId + "/contractors/" + contractorId, data).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Update intervention with given interventionId with given intervention data
     *
     * @since 1.0.0
     *
     * @param interventionId ID of intervention to update
     * @param taxDeductionFeeId ID of taxDeductionFee to update
     * @param data New taxDeductionFee's data
     */
    InterventionsService.prototype.updateTaxDeductionFee = function (interventionId, taxDeductionFeeId, data) {
        var _this = this;
        return this.apiService.apiCall('PUT', "interventions/" + interventionId + "/taxDeductionFees/" + taxDeductionFeeId, data).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Update intervention with given interventionId with given intervention data
     *
     * @since 1.0.0
     *
     * @param interventionId ID of intervention to update
     * @param receivedDocumentId ID of receivedDocument to update
     * @param data New receivedDocument's data
     */
    InterventionsService.prototype.updateReceivedDocument = function (interventionId, receivedDocumentId, data) {
        var _this = this;
        return this.apiService.apiCall('PUT', "interventions/" + interventionId + "/receivedDocuments/" + receivedDocumentId, data).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Update intervention status
     *
     * @since 1.0.0
     *
     * @param interventionId ID of intervention to update
     * @param status New intervention's data
     */
    InterventionsService.prototype.changeStatus = function (interventionId, data) {
        return this.apiService.apiCall('PATCH', "interventions/" + interventionId, data);
    };
    /**
     * Delete permanently a intervention
     *
     * @since 1.0.0
     *
     * @param interventionId ID of the intervention
     */
    InterventionsService.prototype.delete = function (interventionId) {
        return this.apiService.apiCall('DELETE', "interventions/" + interventionId);
    };
    InterventionsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function InterventionsService_Factory() { return new InterventionsService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService), i0.ɵɵinject(i3.TranslateService)); }, token: InterventionsService, providedIn: "root" });
    return InterventionsService;
}());
export { InterventionsService };
